export const PRODUCT_COOKIE_NAME = 'STASH_REG_PRODUCT';
export const STATE_PARAM_COOKIE_NAME = 'AUTH_STATE_PARAM';
export const CODE_VERIFIER_COOKIE_NAME = 'AUTH_CODE_VERIFIER';

export const AUTH_CREATED_ON_WEB_COOKIE_NAME = 'AUTH_CREATED_ON_WEB';
export const AUTH_SESSION_TYPE_COOKIE_NAME = 'AUTH_SESSION_TYPE';

export const IDV_FLOW_NEXT_STEP_COOKIE_NAME = 'idvFlowNextStep';
